import withDatas from '../withDatas'

import defaultStyles from './styles'

const withDataTable = withDatas( defaultStyles ) ;

export default withDataTable ;
